import React, { useEffect, useState } from "react";
import "./LpDocTypes.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import degreeCert from "./../../../vid_img/LandingPage/subServices/Degree.png";
import birthCert from "./../../../vid_img/LandingPage/subServices/Birth.png";
import marriageCert from "./../../../vid_img/LandingPage/subServices/Marriage.png";
import commercialCert from "./../../../vid_img/LandingPage/subServices/Commercial.png";

const LpDocTypesMain = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const [showDots, setShowDots] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setShowDots(window.innerWidth > 768); // Adjust the width as needed
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="lpDoTypeMain-container">
      <Carousel
        responsive={responsive}
        swipeable={true}
        draggable={true}
        showDots={false}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={5000}
        keyBoardControl={true}
        customTransition="1s ease-in-out"
        transitionDuration={500}
        containerClass="carousel-container"
        // removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
      >
        <div>
          <div className="lpDoTypeMain-content">
            <div className="lpDoTypeMain-item">
              <img src={degreeCert} alt="degree Cert" />
            </div>
            <div className="lpDoTypeMain-item">
              <h2>
                <b>01</b> Degree Certificate
              </h2>
              <p>
                <b>Dreaming of studying or working abroad?</b> Make it a
                reality with our Degree Certificate Attestation service – your
                gateway to global opportunities! We ensure your educational
                documents are officially recognized and accepted
                internationally, with a process that's fast, reliable, and 100%
                authentic. Handled by industry experts, so you can skip the
                stress and focus on building your future with confidence.
              </p>
              <Link to="/degree-certificate-attestation-bangalore">
                <button>Know More</button>
                <MdOutlineKeyboardDoubleArrowRight className="arrowIco" />
              </Link>
            </div>
          </div>
        </div>
        <div>
          <div className="lpDoTypeMain-content">
            <div className="lpDoTypeMain-item">
              <img src={marriageCert} alt="marriage Cert" />
            </div>
            <div className="lpDoTypeMain-item">
              <h2>
                <b>02</b> Marriage Certificate
              </h2>
              <p>
                <b>Getting ready to settle abroad with your spouse?</b>{" "}
                Ensure a smooth transition with our Marriage Certificate
                Attestation service – your essential step toward international
                recognition. We help validate your marriage certificate for
                official use overseas through a process that’s fast, secure, and
                100% authentic. Handled by experienced professionals, so you can
                skip the stress and focus on building your future together with
                confidence and peace of mind.
              </p>
              <Link to="/marriage-certificate-attestation-bangalore">
                <button>Know More</button>
                <MdOutlineKeyboardDoubleArrowRight className="arrowIco" />
              </Link>
            </div>
          </div>
        </div>
        <div>
          <div className="lpDoTypeMain-content">
            <div className="lpDoTypeMain-item">
              <img src={birthCert} alt="birth Cert" />
            </div>
            <div className="lpDoTypeMain-item">
              <h2>
                <b>03</b> Birth Certificate
              </h2>
              <p>
                <b>
                  Planning to move abroad for family, education, or residency?
                </b>
                Make it seamless with our Birth Certificate Attestation service
                – your key to international recognition. We ensure your personal
                documents are officially validated and globally accepted,
                through a process that's quick, secure, and 100% genuine.
                Handled by trusted professionals, so you can avoid the hassle
                and focus on your journey ahead with complete peace of mind.
              </p>
              <Link to="/birth-certificate-attestation-bangalore">
                <button>Know More</button>
                <MdOutlineKeyboardDoubleArrowRight className="arrowIco" />
              </Link>
            </div>
          </div>
        </div>
        <div>
          <div className="lpDoTypeMain-content">
            <div className="lpDoTypeMain-item">
              <img src={commercialCert} alt="commercial Cert" />
            </div>
            <div className="lpDoTypeMain-item">
              <h2>
                <b>04</b> Commercial Documents
              </h2>
              <p>
                <b> Expanding your business overseas? </b> Ensure a smooth
                and compliant entry into international markets with our
                Commercial Certificate Attestation service. Whether it’s a
                Memorandum of Association, Power of Attorney, or Export
                Documents, we authenticate your commercial papers for official
                use abroad with a process that’s fast, secure, and 100% genuine.
                Managed by experienced professionals, so you can focus on
                growing your business while we handle the legalities with
                precision and reliability.
              </p>
              <Link to="/commercial-documents-attestation-bangalore">
                <button>Know More</button>
                <MdOutlineKeyboardDoubleArrowRight className="arrowIco" />
              </Link>
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
};

export default LpDocTypesMain;
